function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 661",
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      fill: "#1b74e4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.6a6b9cee2ef619767bb8ce3086e1719a.svg";
export { ForwardRef as ReactComponent };